module.exports = __webpack_public_path__ + "64efda095c8467e5a9c3b5ce4594accd.png";